import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = 'http://10.0.9.7:3001';

const FAQManagerDialog = ({ open, onClose, userId, flowId }) => {
  const [faqFile, setFaqFile] = useState(null);
  const [faqFileName, setFaqFileName] = useState('');
  const [faqs, setFaqs] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Fetch all Q&A pairs for this flow
  const fetchFaqs = async () => {
    if (!userId || !flowId) return;
    try {
      const res = await axios.get(`${API_BASE}/api/faq/${encodeURIComponent(userId)}/${encodeURIComponent(flowId)}`);
      setFaqFileName(res.data.filePath ? res.data.filePath.split('/').pop() : '');
      setFaqs(res.data.faqs || []);
    } catch (err) {
      setFaqFileName('');
      setFaqs([]);
    }
  };

  useEffect(() => {
    if (open && userId && flowId) {
      fetchFaqs();
    }
    // eslint-disable-next-line
  }, [open, userId, flowId]);

  const handleFileChange = (e) => {
    setFaqFile(e.target.files[0]);
    setFaqFileName(e.target.files[0]?.name || '');
    setError('');
    setSuccess('');
  };

  const handleUpload = async () => {
    if (!faqFile || !userId || !flowId) return;
    setUploading(true);
    setError('');
    setSuccess('');
    const formData = new FormData();
    formData.append('faqFile', faqFile);
    formData.append('user_id', userId);
    formData.append('flow_id', flowId);
    try {
      const res = await axios.post(`${API_BASE}/api/faq/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (res.data.success) {
        setSuccess('FAQ uploaded successfully!');
        fetchFaqs();
        setFaqFile(null);
      } else {
        setError(res.data.error || 'Upload failed.');
      }
    } catch (err) {
      setError('Upload failed.');
    }
    setUploading(false);
  };

  if (!open) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog" style={{ width: '500px', maxWidth: '95vw' }}>
        <div className="dialog-header">
          <h2>Manage FAQ</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}>×</button>
        </div>
        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ fontWeight: 500 }}>Upload FAQ File (.txt, question|answer per line):</label>
          <input type="file" accept=".txt" onChange={handleFileChange} style={{ marginTop: '0.5rem' }} />
          {faqFileName && <div style={{ marginTop: '0.5rem', color: '#555' }}>Current file: <b>{faqFileName}</b></div>}
          <button className="btn btn-primary" style={{ marginTop: '1rem' }} onClick={handleUpload} disabled={uploading || !faqFile}>
            {uploading ? 'Uploading...' : 'Upload'}
          </button>
          {error && <div style={{ color: 'red', marginTop: '0.5rem' }}>{error}</div>}
          {success && <div style={{ color: 'green', marginTop: '0.5rem' }}>{success}</div>}
        </div>
        <div style={{ maxHeight: '300px', overflowY: 'auto', background: '#fafafa', borderRadius: '8px', padding: '1rem' }}>
          <h4 style={{ marginBottom: '1rem', color: '#8e24aa' }}>FAQ List</h4>
          {faqs.length === 0 ? (
            <div style={{ color: '#888' }}>No FAQ uploaded yet or file could not be parsed.</div>
          ) : (
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {faqs.map((faq, idx) => (
                <li key={idx} style={{ marginBottom: '1rem', borderBottom: '1px solid #eee', paddingBottom: '0.5rem' }}>
                  <div style={{ fontWeight: 600, color: '#333' }}>Q: {faq.question}</div>
                  <div style={{ color: '#555', marginTop: '0.2rem' }}>A: {faq.answer}</div>
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="dialog-actions">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default FAQManagerDialog; 
